export class PortalConfig {
    // #region Properties
    //Common
    title;
    version;
    versionName;
    versionState;
    pageTitle;
    pageTitleFull;
    footerInfo;
    //Layout
    layoutName;
    //Site
    domain;
    cookiePath;
    loginPageImage;
    loginMethods;
    //consent
    consentCookie;
    statistikCookie;
    consentShowBanner;
    //Api
    viewsUrl;
    apiUrl;
    stsUrl;
    apiClientID;
    apiClientSecret;
    apiScopes;
    //Logging
    loggingUrl;
    googleTag;
    //Options
    options = undefined;
    // #endregion
    // #region Constructor
    constructor(object) {
        //Data
        this.title = object.title;
        this.pageTitle = object.pageTitle;
        this.pageTitleFull = object.pageTitleFull;
        this.version = object.version;
        this.versionName = object.versionName;
        this.versionState = object.versionState;
        this.viewsUrl = object.viewsUrl;
        this.apiUrl = object.apiUrl;
        this.stsUrl = object.stsUrl;
        this.apiClientID = object.apiClientID;
        this.apiClientSecret = object.apiClientSecret;
        this.apiScopes = object.apiScopes;
        this.loginPageImage = object.loginPageImage;
        this.loginMethods = object.loginMethods;
        this.loggingUrl = object.loggingUrl;
        this.footerInfo = object.footerInfo;
        this.consentCookie = object.consentCookie;
        this.statistikCookie = object.statistikCookie;
        this.consentShowBanner = object.consentShowBanner;
        this.layoutName = object.layoutName;
        this.googleTag = object.googleTag;
        //Special
        if (typeof window === 'object') {
            this.domain = window.location.hostname;
        }
        else {
            // eslint-disable-next-line no-restricted-globals
            const url = new URL(self.location.origin);
            this.domain = url.hostname;
        }
        if (utils.isNullOrEmpty(this.layoutName)) {
            this.layoutName = 'g-ecommerce-layout';
        }
        if (!this.loginMethods) {
            this.loginMethods = [];
        }
        if (this.loginMethods.length == 0) {
            this.loginMethods.push({ name: 'user' });
        }
        //Options
        if (object.options) {
            this.options = object.options;
        }
        //Calculate
        this.cookiePath = '/';
    }
    // #endregion
    //#region Core
    getPageTitle(title) {
        if (utils.isNullOrEmpty(title)) {
            return host.config.pageTitle;
        }
        else {
            return utils.format(host.config.pageTitleFull, title);
        }
    }
}
